import React from 'react'
import OrgIntegrations from './components/OrgIntegrations'
import UserIntegrations from './components/UserIntegrations'

function IntegrationSettings({ from }) {
  return from === 'org_settings' ? <OrgIntegrations /> : <UserIntegrations />
}

export default IntegrationSettings
